export default __webpack_public_path__ + "static/media/linkedin.1a3b6e53.svg";